export default __webpack_public_path__ + "static/media/chevron-up-tc_blue.5c04a6bc.svg";